export default "__VITE_PUBLIC_ASSET__3e1bde7d__"